/* web/style.css #map: the space right of the side panel (all of it at phone width). */
.map { position: absolute; inset: 0 0 0 var(--panel-w); }
.canvas { position: absolute; inset: 0; }
.notice { position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); padding: 10px 14px; border-radius: var(--radius); background: var(--surface); color: var(--muted); box-shadow: var(--shadow); font-size: 13px; }
